import React, { useEffect } from "react";
import ExpandableCard from "../../Components/ExpandableCard/ExpandableCard";
import Data from "../../Assets/Content/ContentData.js"; // Import ContentData for links

const AIPage = (props) => {
  useEffect(() => {
    document.title = "Kreislaufwirtschaftsguide | Künstliche Intelligenz";
  }, []);

  const handleNavClick = (e, viewName, cardKey = null) => {
    e.preventDefault();
    if (props.onChangeView) {
      props.onChangeView(viewName, cardKey);
    }
  };

  const cardsData = [
    {
      title: "Künstliche Intelligenz und Kreislaufwirtschaft",
      image: process.env.PUBLIC_URL + "/MDZ_KI_final.png",
      verticalCenter: true,
      jsxContent: (
        <>
          <p>
            Künstliche Intelligenz (KI) umfasst Algorithmen, die aus Daten
            lernen, Muster erkennen und Entscheidungen oder Vorhersagen treffen.
            In der Kreislaufwirtschaft unterstützt KI nachhaltiges Design,
            vorausschauende Wartung, optimierte Produktions- und Absatzplanung
            sowie automatisierte Sortierung und Recycling. Chancen sind
            Ressourceneinsparung, längere Nutzungsdauern und neue zirkuläre
            Geschäftsmodelle. Gleichzeitig entstehen ökologische und soziale
            Risiken: hoher Energiebedarf großer Modelle, Datenschutz- und
            Ethikfragen, Zielkonflikte und Rebound-Effekte. Ergänzend wichtige
            Technologien sind Internet of Things (IoT), Big Data Analytics,
            Datenräume und Digitale Produktpässe, Blockchain, additive
            Fertigung, Rücknahmesysteme und B2B-Plattformen.
          </p>
          <p>
            Schauen Sie sich jede{" "}
            <a
              href="#"
              onClick={(e) => handleNavClick(e, "Intro")}
              style={{ color: "#b80900", fontWeight: "bold" }}
            >
              Produktlebenszyklusphase
            </a>{" "}
            an und identifizieren Sie, wie KI dort konkret eingesetzt werden
            kann.
          </p>
        </>
      ),
    },
    {
      title: "Praxisbeispiel zu KI Anwendungen",
      image: null, // No image -> Full width content
      jsxContent: (
        <div>
          <p>
            Anhand konkreter Praxisbeispiele lässt sich das Potenzial von KI in
            der Kreislaufwirtschaft verdeutlichen. Die folgende Übersicht zeigt
            innovative KI-Lösungen in den jeweiligen Phasen des Kreislaufs.
          </p>
          <div className="mt-4">
            {Object.keys(Data).map((key) => {
              const phase = Data[key];
              if (!phase.example && !phase.examples) return null;

              const examples = phase.examples ? phase.examples : [phase.example];

              return (
                <div key={key} className="mb-4">
                  <h4 style={{ color: "#b80900", cursor: "pointer" }} onClick={(e) => handleNavClick(e, "Intro", key)}>
                    {phase.title}
                  </h4>
                  {examples.map((ex, index) => (
                    <div
                      key={index}
                      className="p-4 rounded shadow-sm mb-3"
                      style={{
                        backgroundColor: "#fff5f5",
                        borderLeft: "4px solid #b80900",
                      }}
                    >
                      <div className="d-flex align-items-center mb-2">
                        <i
                          className="bi bi-lightbulb me-2"
                          style={{ fontSize: "1.5rem", color: "#b80900" }}
                        ></i>
                        <h5 className="mb-0" style={{ color: "#b80900", fontWeight: "bold" }}>
                          {ex.title}
                        </h5>
                      </div>
                      <div style={{ textAlign: "justify" }}>
                        <p className="mb-0">{ex.text}</p>
                      </div>
                      {ex.link && (
                        <div className="mt-3">
                          <a
                            href={ex.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm btn-outline-danger"
                            style={{
                              borderColor: "#b80900",
                              color: "#b80900",
                            }}
                            onMouseOver={(e) => {
                              e.target.style.backgroundColor = "#b80900";
                              e.target.style.color = "#fff";
                            }}
                            onMouseOut={(e) => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.color = "#b80900";
                            }}
                          >
                            Zum Praxisbeispiel
                          </a>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="container mt-4 mb-5">
      <div className="row justify-content-center">
        <div className="col-lg-12">
          {cardsData.map((card, index) => (
            <ExpandableCard
              key={index}
              title={card.title}
              content={card.content}
              image={card.image}
              initiallyOpen={index === 0}
              verticalCenter={card.verticalCenter}
            >
              {card.jsxContent}
            </ExpandableCard>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AIPage;
